import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export function parseBirthdayToDayjs(stored: string | null | undefined): Dayjs | null {
  if (!stored) return null;
  const asDDMMYYYY = dayjs(stored, "DD/MM/YYYY", true);
  if (asDDMMYYYY.isValid()) return asDDMMYYYY;
  const asISO = dayjs(stored);
  return asISO.isValid() ? asISO : null;
}

export function formatBirthday(d: Dayjs | string | null | undefined): string {
  return d && dayjs(d).isValid() ? dayjs(d).format("DD/MM/YYYY") : "";
}